import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
import locale from "element-plus/lib/locale/lang/zh-cn"; //中文
import axios from "axios";
import Video from "video.js";
import "video.js/dist/video-js.css";
import utils from "./untils/utils";
import regular from "./untils/regular";
import "@/assets/css/common.less";
import "@/assets/css/style.less";
import * as echarts from "echarts";
import cookie from "@/assets/js/cookie.js";
import * as socketApi from '@/api/wssocket';
import registerDirectives from './untils/directive'
var app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

import api from "@/api/login_api";
import moment from "moment";
setInterval(function (){
  if(cookie.getCookie("college_token") && cookie.getCookie("activeStartId")){
    api
      .useractiveEnd({
        endTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        transId: cookie.getCookie("activeStartId")
      })
      .then((resSS) => {
        if(resSS.status == 0){
          
        }
      });
  }
},300000)

app.config.globalProperties.$utils = utils;
app.config.globalProperties.$regular = regular;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$video = Video;
app.config.globalProperties.$echarts = echarts;
app.config.globalProperties.$wsApi = socketApi;

router.beforeEach((to, from, next) => {
  utils.setDocumentTabTitle();
  
  let userInfo = JSON.parse(cookie.getCookie("college_user"));
  if (userInfo == null) {
    next();
    return;
  }

  let college = "";
  let collegeConfig = JSON.parse(sessionStorage.getItem("kSysCollegeConfig"));
  if (collegeConfig != null && Object.keys(collegeConfig).length > 0) {
    if (!utils.isEmptyString(collegeConfig.collegetag)) {
      college = collegeConfig.collegetag;
    }
  }
  if (utils.isEmptyString(to.query.college) && !utils.isEmptyString(college)) {
    let query = to.query;
    query.college = college;
    next({
      path: to.path,
      params: to.params,
      query: query,
    });
  } else {
    next();
  }
});
registerDirectives(app);
app.use(ElementPlus, { locale }).use(store).use(router);
app.mount("#app");
